import React from 'react';
import { Form, Input, Radio } from 'antd';
import GenericDialog from '@common/GenericDialog';

const CreatePreTestDialog = ({
                                 open,
                                 onClose,
                                 createPreTestForm,
                                 addQuestionsNow,
                                 onChangeAddNow,
                                 onCreatePreTest,
                                 createTestDescription,
                             }) => {
    return (
        <GenericDialog
            title="Add pre/mid test to this family"
            contentStyle={{ width: '450px' }}
            open={open}
            onClose={() => {
                onClose();
                createPreTestForm.resetFields();
            }}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' },
                },
                {
                    name: 'Create',
                    callback: onCreatePreTest,
                },
            ]}
        >
            <p>{createTestDescription}</p>
            <Form
                className="testFamilyForm"
                form={createPreTestForm}
                initialValues={{ addQuestionsNow: false, useWizard: true }}
                labelCol={{ span: 9 }}
                wrapperCol={{ span: 16 }}
            >
                <Form.Item
                    label="Name"
                    name="testName"
                    rules={[
                        { required: true, message: 'Please input a name.' },
                    ]}
                >
                    <Input placeholder="Name" />
                </Form.Item>
                <Form.Item
                    label="Description"
                    name="testDescription"
                >
                    <Input.TextArea placeholder="Description" />
                </Form.Item>
                <Form.Item label="Add questions" name="addQuestionsNow">
                    <Radio.Group
                        options={[
                            { label: 'Now', value: true },
                            { label: 'Later', value: false },
                        ]}
                        onChange={onChangeAddNow}
                        optionType="button"
                        buttonStyle={"solid"}
                    />
                </Form.Item>
                <Form.Item
                    label="How to add questions"
                    name="useWizard"
                    rules={[
                        {
                            required: addQuestionsNow,
                            message: 'Please select how to add questions.',
                        },
                    ]}
                >
                    <Radio.Group
                        options={[
                            { label: 'Manual', value: false },
                            { label: 'Wizard', value: true },
                        ]}
                        optionType="button"
                        disabled={!addQuestionsNow}
                        buttonStyle={"solid"}
                    />
                </Form.Item>
            </Form>
        </GenericDialog>
    );
};

export default CreatePreTestDialog;
